import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Heading } from '../../typography/Heading/Heading.js';
import { twMerge } from '../../utils/twMerge.js';
export const DialogTitle = forwardRef(function DialogTitle(props, forwardedRef) {
    return (_jsx(Heading, { ...props, ref: forwardedRef, slot: "title", level: "h1", visualLevel: "h5", className: twMerge('ppl-DialogTitle mb-0 pt-2', props.className) }));
});
//# sourceMappingURL=DialogTitle.js.map